import React from "react";
import swal from "sweetalert";
import { BASE_URL } from "./utility";
import MenuBar from "./navbar";
import Header from "./header";
import { Container } from "react-bootstrap";

class NameForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { username: "", password: "" };
  }

  handleSubmit = (event) => {
    event.preventDefault();

    fetch(BASE_URL + "login", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        username: this.state.username,
        password: this.state.password,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.result === "success") {
          localStorage.setItem("token", responseJson.token);
          localStorage.setItem("loginTime", new Date().getTime());
          window.location.href = "/operations";
        } else {
          swal(responseJson.message);
        }
      })
      .catch((error) => console.error(error));
  };

  render() {
    return (
      <div
        style={{
          backgroundImage: `url(${BASE_URL + "download/general/bg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingBottom: "3rem",
          minHeight: "100vh",
        }}
      >
        {/* SAME as About */}
        <Header />
        <MenuBar />

        <Container style={{ marginTop: "3rem" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <form
              onSubmit={this.handleSubmit}
              style={{
                background: "#fff",
                borderRadius: "15px",
                padding: "30px 40px",
                width: "100%",
                maxWidth: "400px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}
            >
              <h3
                style={{
                  textAlign: "center",
                  marginBottom: "25px",
                  fontWeight: "600",
                }}
              >
                Sign In
              </h3>

              <input
                type="text"
                placeholder="Enter username"
                value={this.state.username}
                onChange={(e) =>
                  this.setState({ username: e.target.value })
                }
                style={{
                  width: "100%",
                  padding: "12px",
                  marginBottom: "15px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                }}
              />

              <input
                type="password"
                placeholder="Enter password"
                value={this.state.password}
                onChange={(e) =>
                  this.setState({ password: e.target.value })
                }
                style={{
                  width: "100%",
                  padding: "12px",
                  marginBottom: "20px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                }}
              />

              <button
                type="submit"
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "8px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  border: "none",
                  fontWeight: "600",
                }}
              >
                Login
              </button>
            </form>
          </div>
        </Container>
      </div>
    );
  }
}

export default NameForm;
